import React, {Component} from 'react';
import {BrowserRouter, Switch} from 'react-router-dom';
import {IndexRoutes} from './index/Config';
import {Route} from "react-router-dom";
import Reload from "../modules/common/components/Reload";
import {HelpRoutes} from "./help/Config";
import Loadable from 'react-loadable';

//
const loading = () => <div/>;

//
const DefaultLayout = Loadable({
    loader: () => import('../modules/common/layouts/default/Layout'),
    render(loaded, props) {
        let Component = loaded.default;
        return <Component {...props} />;
    },
    loading,
});

//
const AccountLayout = Loadable({
    loader: () => import('../modules/help/layout/Layout'),
    render(loaded, props) {
        let Component = loaded.default;
        return <Component {...props} />;
    },
    loading,
});


//
class Routes extends Component {

    //
    getPathsArr = (routesList) => {
        let arr = [];
        routesList.forEach(item => {
            const temp = item.path;
            arr.push(temp);
        });
        return arr;
    }

    render() {
        return <BrowserRouter>
            <Route exact path='/reload' component={Reload}/>
            <Route exact path={this.getPathsArr(IndexRoutes)}>
                <Switch>
                    <DefaultLayout {...this.props}>
                        {IndexRoutes.map((route, index) => {
                            return (
                                !route.children ?
                                    <Route
                                        key={index}
                                        path={route.path}
                                        exact={route.exact}
                                        component={route.component}>
                                    </Route>
                                    : null
                            );
                        })}
                    </DefaultLayout>
                </Switch>
            </Route>
            <Route exact path={this.getPathsArr(HelpRoutes)}>
                <Switch>
                    <AccountLayout {...this.props}>
                        {HelpRoutes.map((route, index) => {
                            return (
                                !route.children ?
                                    <Route
                                        key={index}
                                        path={route.path}
                                        // roles={route.roles}
                                        // exact={route.exact}
                                        component={route.component}>
                                    </Route>
                                    : null
                            );
                        })}
                    </AccountLayout>
                </Switch>
            </Route>
        </BrowserRouter>
    }
}

export default Routes;
